import Reveal from '@/components/base/Reveal';
import { chapters } from '@/mocks/comicData';

export default function Updates() {
  return (
    <section id="updates" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              追更动态
              <span className="h-px w-8 bg-primary-500" />
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black md:text-4xl">最新章节 · 一话一亮点</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              想跟上连载进度？这里整理了最新章节的标题与看点，方便你快速回顾、不错过关键转折。
            </p>
          </div>
        </Reveal>

        <div className="mx-auto mt-10 max-w-4xl">
          <div className="flex flex-col gap-3">
            {chapters.map((c, i) => (
              <Reveal key={c.tag} delay={i * 50}>
                <div className="group flex flex-col gap-2 rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-primary-200 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex items-start gap-4">
                    <span className="whitespace-nowrap rounded-md bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
                      {c.tag}
                    </span>
                    <div>
                      <h3 className="font-heading text-base font-bold text-foreground-950">{c.title}</h3>
                      <p className="mt-1 text-sm text-foreground-700">{c.desc}</p>
                    </div>
                  </div>
                  <span className="flex items-center gap-1 whitespace-nowrap pl-1 text-xs text-foreground-500">
                    <i className="ri-time-line" />
                    已上线
                  </span>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={120}>
            <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg border border-primary-200 bg-gradient-to-r from-primary-50 to-accent-50 p-6 sm:flex-row">
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950">想入坑但不知从何看起？</h3>
                <p className="mt-1 text-sm text-foreground-700">
                  建议按「漫画简介 → 分卷剧情 → 结局解析」的顺序阅读，一页就能把故事脉络摸清楚。
                </p>
              </div>
              <a
                href="#intro"
                className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                回到漫画简介
                <i className="ri-arrow-up-line ml-1.5" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}